interface TabProps {
  loading: boolean
  tabs: Object[] | []
  selectedTab?: string
  setSelectedTab?: any
}

export default function Tabs({loading, tabs, selectedTab, setSelectedTab}: TabProps) {
  const tabChange = (tab: string) => {
    setSelectedTab(tab)
  }

  const findActive = (tab, selectedTab) => {
    if (tab.childs) {
      for (let i = 0; i < tab.childs.length; i++) {
        if (tab.childs[i]?.key === selectedTab) return 'active'
      }
    }

    if (tab.key === selectedTab) return 'active'

    return ''
  }

  return (
    <>
      <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold'>
        {tabs.map((tab, index) =>
          tab.childs ? (
            <li className={'nav-item dropdown mt-2 me-10 min-w-340px'} key={index}>
              <button
                onClick={() => {
                  if (tab?.key) tabChange(tab?.key)
                }}
                id='tab-elm'
                data-bs-toggle='dropdown'
                data-kt-menu-static='true'
                aria-expanded='false'
                className={'nav-link dropdown-toggle ' + findActive(tab, selectedTab)}
              >
                {tab?.label}
              </button>
              <ul className={`dropdown-menu py-5`}>
                <div className='d-flex flex-column gap-4'>
                  {tab.childs.map((child, index) => (
                    <li key={index}>
                      <button onClick={() => tabChange(child?.key)} className='nav-link nav-item'>
                        {child?.label}
                      </button>
                    </li>
                  ))}
                </div>
              </ul>
            </li>
          ) : (
            <li className='nav-item mt-2' key={index}>
              <button
                onClick={() => tabChange(tab?.key)}
                className={
                  'nav-link text-active-secondary ms-0 me-10 py-5 ' + findActive(tab, selectedTab)
                }
              >
                {tab?.label}
              </button>
            </li>
          )
        )}
      </ul>
    </>
  )
}
